import React, { useEffect, useState } from "react";
import { getOrders } from "../services/getOrders";
import { useUser } from '../Context/UserContext';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Divider } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HistoryIcon from '@mui/icons-material/History';
import HelpIcon from '@mui/icons-material/Help';
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import UserBox from "../components/Boxes/UserBox";
import CardListShoppingCart from "../components/Card/ShoppingCartCards/CardsListShoppingCart";
import CardsListShoppingHistory from "../components/Card/ShoppingHistory/CardsListShoppingHistory";
import './ProfilePage.css';

const ProfilePage = () => {
    const [selectedIndex, setSelectedIndex] = useState(1); // Por defecto, carrito
    const { user, setUser } = useUser();

    // Cargar el índice de la pestaña desde localStorage
    useEffect(() => {
        const storedIndex = localStorage.getItem("selectedIndex");
        if (storedIndex !== null) {
            setSelectedIndex(parseInt(storedIndex, 10)); // Convertir a número
        }
    }, []);

    // Guardar el índice de la pestaña en localStorage cuando cambie
    useEffect(() => {
        localStorage.setItem("selectedIndex", selectedIndex);
    }, [selectedIndex]);

    const handleListItemClick = (event, index) => {
        if (index !== selectedIndex) {
            setSelectedIndex(index);
        }
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, [setUser]);

    return (
        <>
            <Header />
            <div style={{ padding: 100, justifyContent: 'center', display: 'flex', alignContent: 'center', minHeight: '50vh' }}>
                <div>
                    <Box className='list-box' style={{ padding: 10 }}>
                        <div className="Acc-Name">
                            {user?.name || "Usuario desconocido"}
                        </div>
                        <List component="nav" aria-label="main mailbox folders">
                            <ListItemButton
                                selected={selectedIndex === 1}
                                onClick={(event) => handleListItemClick(event, 1)}
                            >
                                <ListItemIcon>
                                    <ShoppingCartIcon />
                                </ListItemIcon>
                                <ListItemText primary="Carrito" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <List component="nav" aria-label="secondary mailbox folder">
                            <ListItemButton
                                selected={selectedIndex === 0}
                                onClick={(event) => handleListItemClick(event, 0)}
                            >
                                <ListItemIcon>
                                    <AccountCircleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Información" />
                            </ListItemButton>
                            <ListItemButton
                                selected={selectedIndex === 2}
                                onClick={(event) => handleListItemClick(event, 2)}
                            >
                                <ListItemIcon>
                                    <HistoryIcon />
                                </ListItemIcon>
                                <ListItemText primary="Historial de Compras" />
                            </ListItemButton>
                            <ListItemButton
                                selected={selectedIndex === 3}
                                onClick={(event) => handleListItemClick(event, 3)}
                            >
                                <ListItemIcon>
                                    <HelpIcon />
                                </ListItemIcon>
                                <ListItemText primary="Ayuda" />
                            </ListItemButton>
                        </List>
                    </Box>
                </div>
                <UserBox user={user} displayThis={selectedIndex} />
                <CardListShoppingCart displayThis={selectedIndex} />
                <CardsListShoppingHistory displayThis={selectedIndex} />
            </div>
            <Footer />
        </>
    );
};

export default ProfilePage;
